import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays weather summary information
 * @param {Object} props
 * @param {import('./routeInfo.types').WeatherSummary} props.weatherSummary
 */
const RouteInfoWeather = ({ weatherSummary }) => {
  if (!weatherSummary) {
    return null;
  }

  const { avgWindSpeed, maxWindSpeed, avgWaveHeight, precipitationTotal } = weatherSummary;

  return (
    <div className="route-info-section">
      <h3 className="section-title">Weather Conditions</h3>
      <div className="weather-grid">
        <div className="weather-item">
          <span className="weather-label">Avg Wind</span>
          <span className="weather-value">{avgWindSpeed.toFixed(1)} kts</span>
        </div>
        <div className="weather-item">
          <span className="weather-label">Max Wind</span>
          <span className="weather-value">{maxWindSpeed.toFixed(1)} kts</span>
        </div>
        {avgWaveHeight !== undefined && (
          <div className="weather-item">
            <span className="weather-label">Avg Wave Height</span>
            <span className="weather-value">{avgWaveHeight.toFixed(1)} m</span>
          </div>
        )}
        {precipitationTotal !== undefined && (
          <div className="weather-item">
            <span className="weather-label">Precipitation</span>
            <span className="weather-value">{precipitationTotal.toFixed(1)} mm</span>
          </div>
        )}
      </div>
    </div>
  );
};

RouteInfoWeather.propTypes = {
  weatherSummary: PropTypes.shape({
    avgWindSpeed: PropTypes.number.isRequired,
    maxWindSpeed: PropTypes.number.isRequired,
    avgWaveHeight: PropTypes.number,
    precipitationTotal: PropTypes.number,
  }),
};

export default RouteInfoWeather;